import gql from 'graphql-tag';

export interface Teaser {
  id: string;
  teaserAnimation?: TeaserAnimation;
  teaserImages?: TeaserImage;
}

interface TeaserAnimation {
  id: string;
  reference: string;
  startTime: number;
  fps: number;
  duration: number;
  width: number;
  height: number;
}

interface TeaserImage {
  id: string;
  interval: number;
  width: number;
  height: number;
  maxHorizontal: number;
  maxVertical: number;
  items: [{
    reference: string;
    time: number;
  }];
}

const TEASER_IMAGE_ITEM_FRAGMENT = gql`
  fragment TeaserImageItem on GQLTeaserImage {
    reference
    time
  }
`;

export const TEASER_IMAGES_FRAGMENT = gql`
  fragment TeaserImages on GQLTeaserImageList {
    id
    interval
    width
    height
    maxHorizontal
    maxVertical
    items {
      ...TeaserImageItem
    }
  }
  ${TEASER_IMAGE_ITEM_FRAGMENT}
`;

export const TEASER_ANIMATION_FRAGMENT = gql`
  fragment TeaserAnimation on GQLTeaserAnimation {
    id
    reference
    startTime
    fps
    duration
    width
    height
  }
`;

export const TEASER_FRAGMENT = gql`
  fragment Teaser on GQLTeaser {
    id
    teaserAnimation {
      ...TeaserAnimation
    }
    teaserImages {
      ...TeaserImages
    }
  }
  ${TEASER_IMAGES_FRAGMENT}
  ${TEASER_ANIMATION_FRAGMENT}
`;

export const GET_TEASER_QUERY = gql`
  query getTeaser($id: ID!) {
    video(id: $id) {
      teaser {
        id
        teaserAnimation {
          ...TeaserAnimation
        }
      }
    }
  }
  ${TEASER_ANIMATION_FRAGMENT}
`;
